module.exports = __webpack_public_path__ + "img/congrex-bo-logo-v2.0e169357.png";